import { Component, Input, OnInit } from "@angular/core";
import { AssistantActions, AssistantActionButton } from "../../../models";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-banner-action-buttons",
    templateUrl: "./assistant-banner-action-buttons.component.html",
    styleUrls: ["./assistant-banner-action-buttons.component.scss"],
    standalone: false
})
export class AssistantBannerActionButtonsComponent implements OnInit {
  @Input() actions: AssistantActions;

  constructor(private assisantService: AssistantService) {}

  ngOnInit(): void {}

  onActionBtnClick(btn: AssistantActionButton): void {
    this.assisantService.raiseActionButton(btn);
  }
}
